var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExitRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M64 32 30.72 12.8v12.8H0v12.8h30.72v12.8z"
})));
export { SvgExitRight as ReactComponent };